module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.eot
// module id = 14
// module chunks = 0